omadappData = {}